export default __webpack_public_path__ + "a664d5bb11bbdc17f4325b678cd37ee2.png";